<template>
  <div id="navbar">
    <nav :class="['sidebar-navigation', { menuCollapsed }]">
      <ul class="nav-scroll-list">
        <li class="my-3 mx-2 logo-container">
          <a href="https://dmp-maps.com/" target="_blank">
            <img src="../../../assets/dmpLogo.png" alt="Banner" class="logo" /></a>
          <span class="ml-1 label">Dynamic Map Platform</span>
          <span v-if="versionReleaseInfo" class="ml-1 label version-label">MMP - Version {{ versionReleaseInfo.version }}</span>
        </li>

        <li class="active" @click="handleMenu('Dashboard')" id="Dashboard" :title="menuCollapsed ? 'Dashboard' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'home']"></fa></span>
            <span class="ml-3 label">Dashboard</span>
          </div>
        </li>

        <li @click="handleMenu('DemoDRT')" id="DRT" :title="menuCollapsed ? 'DRT' : null" v-if="globalIsUserAllowed('Sales_Demo_DRT')">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'history']"></fa></span>
            <span class="ml-3 label">Demo DRT</span>
          </div>
        </li>
        <li @click="handleMenu('ProdDRT')" id="DRT" :title="menuCollapsed ? 'DRT' : null" v-if="globalIsUserAllowed('Sales_Prod_DRT')">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'globe']"></fa></span>
            <span class="ml-3 label">Production DRT</span>
          </div>
        </li>

        <li @click="handleMenu('WCL')" id="WCL" :title="menuCollapsed ? 'WCL' : null" v-if="globalIsUserAllowed('WCL')">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'road']"></fa></span>
            <span class="ml-3 label">Web Coverage</span>
          </div>
        </li>

        <li @click="handleMenu('MMP')" id="MMP" :title="menuCollapsed ? 'MMP' : null" v-if="globalIsUserAllowed('MMP')">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'globe-americas']"></fa></span>
            <span class="ml-3 label">MMP</span>
          </div>
        </li>

        <li class="has-submenu" id="DT" :class="{ open: groups.dataTools }" :title="menuCollapsed ? 'Data Tools' : null" v-if="globalIsUserAllowed('Data_Delivery_Tool') && globalIsUserAllowed('Trail_Review_Tool')">
          <div class="text_format" @click="handleGroupOrNav('DT', 'dataTools')">
            <span class="nav-icon"><fa :icon="['fas', 'database']"></fa></span>
            <span class="ml-3 label">Data Tools</span>
            <fa :icon="['fas', 'angle-right']" class="submenu-arrow label" @click.stop="toggleGroup('dataTools')" />
          </div>
          <ul class="submenu mx-4 mt-1" v-if="globalIsUserAllowed('Data_Delivery_Tool') && globalIsUserAllowed('Trail_Review_Tool')">
            <li class="submenu-item ml-3" @click="handleMenu('DDT')" v-if="globalIsUserAllowed('Data_Delivery_Tool')">
              <span class="submenu-item-icon"><fa :icon="['fas', 'database']" /></span>
              <span class="submenu-item-text">Data Delivery Tool</span>
            </li>
            <li class="submenu-item ml-3" @click="handleMenu('TRT')" v-if="globalIsUserAllowed('Trail_Review_Tool')">
              <span class="submenu-item-icon"><fa :icon="['fas', 'map']" /></span>
              <span class="submenu-item-text">Trail Review Tool</span>
            </li>
          </ul>
        </li>

        <li v-if="mapsMode" @click="handleMenu('SignOut')" class="logout" :title="menuCollapsed ? 'Sign Out' : null">
          <div class="text_format">
            <span class="nav-icon"><fa :icon="['fas', 'sign-out-alt']"></fa></span>
            <span class="ml-3 label">Sign Out</span>
          </div>
        </li>

      </ul>
      <ul class="nav-collapse-list">
        <li class="nav-collapse-toggle" @click="toggleCollapse()" :title="menuCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
          <div class="nav-toggle-inner">
            <span class="nav-toggle-btn" :class="{ collapsed: menuCollapsed }">
              <fa :icon="['fas', 'angle-left']" class="nav-toggle-icon"></fa>
            </span>
            <span class="nav-toggle-text label">Collapse</span>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<style src="./Generic.css" scoped></style>
<style scoped>
.logo-container .version-label {
  display: block;
  font-weight: 400;
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.02em;
}

.nav-collapse-toggle {
  padding: 0.625rem 0 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.nav-collapse-toggle:hover {
  background-color: rgba(6, 47, 86, 0.65) !important;
}

.nav-toggle-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;
}

.nav-toggle-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(152, 215, 236, 0.25);
  transition: background 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease, transform 0.35s ease;
}

/* Chevron points left when expanded, flips to point right when collapsed. */
.nav-toggle-btn.collapsed {
  transform: rotate(180deg);
}

/* Hover styling deliberately avoids `transform` so the collapsed rotation
   above is never clobbered by specificity. */
.nav-collapse-toggle:hover .nav-toggle-btn {
  background: rgba(152, 215, 236, 0.18);
  border-color: rgba(152, 215, 236, 0.6);
  box-shadow: 0 0 0 3px rgba(152, 215, 236, 0.08);
}

.nav-toggle-icon {
  font-size: 0.8rem;
  color: #cce8f5;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.nav-collapse-toggle:hover .nav-toggle-icon {
  opacity: 1;
}

.nav-toggle-text {
  font-size: 0.7rem;
  font-weight: 500;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #98d7ec;
  opacity: 0.7;
}

/* ── Animated accordion submenu (matches DT_NavBar) ─────────── */
.has-submenu .text_format {
  display: flex;
  align-items: center;
  width: 100%;
}

.submenu-arrow {
  margin-left: auto;
  margin-right: 0.625rem;
  font-size: 0.95rem;
  opacity: 0.5;
  transition: opacity 0.2s ease, transform 0.25s ease;
}

.has-submenu.open .submenu-arrow {
  opacity: 1;
  transform: rotate(90deg);
}

.submenu {
  position: static;
  list-style: none;
  margin: 0 0 0 1.125rem;
  padding-left: 0.3125rem;
  padding-right: 0.3125rem;
  max-height: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.18);
  border-left: 2px solid #1a6ea8;
  border-radius: 0 0 6px 6px;
  transition: max-height 0.3s ease, padding 0.25s ease;
}

.has-submenu.open .submenu {
  max-height: 12.5rem;
  padding: 0.25rem 0 0.375rem;
}

.sidebar-navigation.menuCollapsed .has-submenu.open .submenu {
  max-height: 0;
  padding: 0;
}

.submenu-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  color: #cce8f5;
  transition: background 0.15s ease, color 0.15s ease, padding-left 0.15s ease;
}

.submenu-item:hover {
  background: rgba(26, 110, 168, 0.35);
  color: #ffffff;
  padding-left: 1rem;
}

.submenu-item-icon {
  width: 1.125rem;
  text-align: center;
  font-size: 0.85rem;
  color: #98d7ec;
  flex-shrink: 0;
}

.submenu-item-text {
  font-size: 0.76rem;
  font-weight: 300;
  white-space: nowrap;
}
</style>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'NavBar',
  props: ['menuCollapsed', 'mapsMode', 'versionReleaseInfo'],
  data() {
    return {
      groups: {
        dataTools: false
      }
    }
  },
  computed: {
    ...mapGetters(['globalUserRole', 'globalAllowedUserModules', 'globalIsUserAllowed'])
  },
  mounted() {
    // this.$emit('vehiclesMap')
  },
  methods: {
    toggleCollapse() {
      this.$emit('toggleCollapse')
    },
    toggleGroup(name) {
      if (this.menuCollapsed) {
        // Expand the whole sidebar first — a submenu can't show while collapsed,
        // so a click here means "show me my options," not just "toggle."
        this.$emit('toggleCollapse')
        this.groups[name] = true
      } else {
        this.groups[name] = !this.groups[name]
      }
    },
    handleGroupOrNav(option, groupName) {
      if (this.menuCollapsed) {
        this.toggleGroup(groupName)
      } else {
        this.handleMenu(option)
      }
    },
    setActive(activeID) {
      let activeElements = document.getElementsByClassName('active')
      Array.from(activeElements).forEach((li) => {
        li.className = '';
      });

      let active = document.getElementById(activeID)
      if (active) {
        active.className = 'active'
      }
    },
    async handleMenu(option) {
      this.setActive(option)
      switch (option) {
        case 'DT':
          this.$router.push({name: 'DataTools'}).catch(() => {})
          break;
        case 'DDT':
          this.$router.push({ name: 'DDT', query: { openMap: '1' } }).catch(() => {})
          break;
        case 'TRT':
          this.$router.push({ name: 'TRT', query: { openMap: '1' } }).catch(() => {})
          break;
        case 'Dashboard':
          await new Promise(resolve => {
            this.$emit('reset', resolve)
          })
          this.$emit('vehiclesMap');
          break;
        case 'DemoDRT':
          await new Promise(resolve => {
            this.$emit('reset', resolve)
          })
          this.$emit('loadProject', 'DemoDRT')
          break;
        case 'ProdDRT':
          await new Promise(resolve => {
            this.$emit('reset', resolve)
          })
          this.$emit('loadProject', 'ProdDRT')
          break;
        case 'WCL':
          await new Promise(resolve => {
            this.$emit('reset', resolve)
          })
          this.$emit('loadProject', 'WCL')
          break;
        case 'MMP':
          this.$router.push({ name: 'MMP' }).catch(() => {})
          break;
        case 'SignOut':
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('pid')
          this.$emit('clearCurrentPositionsInterval')
          this.$router.push({ name: 'Login' })
          break;
      }
    }
  }
}
</script>